export const PAGINATION_DEFAULTS = {
  PER_PAGE: 20,
  INITIAL_PAGE: 1,
  SCROLL_THRESHOLD: 100,
} as const;
